<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="2"
        md="2"
        lg="2"
      >
        <v-select
          v-if="enableOpcao"
          v-model="exibicaoSelect"
          :items="exibicao"
          item-value="id"
          item-text="texto"
          label="Opçao de Exibição"
          return-object
          @change="getOpcao(exibicaoSelect)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="10"
        md="10"
        lg="10"
      >
        <div
          v-if="loading"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <div>
          <canvas
            id="myChartMaisVida1"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import VolumePreco from '../../../../services/volumepreco'
  import eventEmit from '../../components/core/EventoEmit'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'DashboardChartLineBar',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      produtos: [],
      linhas: [],
      volume: [],
      precoMedio: [],
      clientes: [],
      segmento: [],
      exibicao: [
        { id: 1, texto: 'Diário' },
        { id: 2, texto: 'Semanal' },
        { id: 3, texto: 'Mensal' },
      ],
      exibicaoSelect: [],
      labelsDiario: [],
      volumeDiario: [],
      precoDiario: [],
      labelsSemanal: [],
      volumeSemanal: [],
      precoSemanal: [],
      labelsMensal: [],
      volumeMensal: [],
      precoMensal: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
      enableOpcao: false,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, segmento) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.segmento = segmento

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.exibicaoSelect = []
        this.enableOpcao = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await VolumePreco.showDadosVolumeXPrecoMedio(this.dataInicial, this.dataFinal, this.empresaSelect, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, localStorage.tokencontrato, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.exibicaoSelect = this.exibicao.find(item => item.id === 3)

            this.enableOpcao = true
            this.labelsDiario = resposta.data.datas
            this.volumeDiario = resposta.data.volume
            this.precoDiario = resposta.data.precoMedio
            this.labelsSemanal = resposta.data.datasSemanais
            this.volumeSemanal = resposta.data.volumeSemanais
            this.precoSemanal = resposta.data.precoMedioSemanais
            this.labelsMensal = resposta.data.datasMensal
            this.volumeMensal = resposta.data.volumeMensal
            this.precoMensal = resposta.data.precoMedioMensal

            const ctx = document.getElementById('myChartMaisVida1').getContext('2d')

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'line',
              data: {
                labels: this.labelsMensal,
                datasets: [
                  {
                    label: 'Volume',
                    data: this.volumeMensal,
                    backgroundColor: 'transparent',
                    borderColor: '#ed934f',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return 'Volume: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    title: (tooltipItem) => {
                      return 'Mês - ' + tooltipItem[0].xLabel
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value, context) => {
                      return this.precoMensal[context.dataIndex].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    align: 'start',
                    offset: 2,
                    rotation: 270,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Não há dados com os filtros selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      getOpcao (value) {
        if (value.id === 1) {
          if (this.myChart.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('myChartMaisVida1').getContext('2d')

          this.myChart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: 'line',
            data: {
              labels: this.labelsDiario,
              datasets: [
                {
                  label: 'Volume',
                  data: this.volumeDiario,
                  backgroundColor: 'transparent',
                  borderColor: '#ed934f',
                  order: 1,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
              low: 10,
              high: 5,
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    return 'Volume: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  },
                  title: (tooltipItem) => {
                    return 'Dia - ' + tooltipItem[0].xLabel
                  },
                },
              },
              plugins: {
                datalabels: {
                  display: true,
                  color: function (context) {
                    return '#000000'
                  },
                  font: {
                    size: 11,
                  },
                  formatter: (value, context) => {
                    return this.precoDiario[context.dataIndex].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                  },
                  align: 'end',
                  offset: 2,
                  rotation: 270,
                },
              },
            },
          })
        } else if (value.id === 2) {
          if (this.myChart.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('myChartMaisVida1').getContext('2d')

          this.myChart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: 'line',
            data: {
              labels: this.labelsSemanal,
              datasets: [
                {
                  label: 'Volume',
                  data: this.volumeSemanal,
                  backgroundColor: 'transparent',
                  borderColor: '#ed934f',
                  order: 1,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
              low: 10,
              high: 5,
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    return 'Volume: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  },
                  title: (tooltipItem) => {
                    return 'Semana - ' + tooltipItem[0].xLabel
                  },
                },
              },
              plugins: {
                datalabels: {
                  display: true,
                  color: function (context) {
                    return '#000000'
                  },
                  font: {
                    size: 11,
                  },
                  formatter: (value, context) => {
                    return this.precoSemanal[context.dataIndex].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                  },
                  align: 'start',
                  offset: 2,
                  rotation: 270,
                },
              },
            },
          })
        } else if (value.id === 3) {
          if (this.myChart.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('myChartMaisVida1').getContext('2d')

          this.myChart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: 'line',
            data: {
              labels: this.labelsMensal,
              datasets: [
                {
                  label: 'Volume',
                  data: this.volumeMensal,
                  backgroundColor: 'transparent',
                  borderColor: '#ed934f',
                  order: 1,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
              low: 10,
              high: 5,
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    return 'Volume: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  },
                  title: (tooltipItem) => {
                    return 'Mês - ' + tooltipItem[0].xLabel
                  },
                },
              },
              plugins: {
                datalabels: {
                  display: true,
                  color: function (context) {
                    return '#000000'
                  },
                  font: {
                    size: 11,
                  },
                  formatter: (value, context) => {
                    return this.precoMensal[context.dataIndex].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                  },
                  align: 'start',
                  offset: 2,
                  rotation: 270,
                },
              },
            },
          })
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">
  #myChartMaisVida1
    font-size: 20px
    display: center
    align-items: center
    font-weight: bold

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
